export const WEIGHT_SCHEMA_CODE = 'PSWEIGHTINGSCHEMA';
